<template>
  <span>
    <span v-if="scope.scope.actionList && scope.scope.actionList.length > 0">
      <span v-for="item in scope.scope.actionList" :key="item.name">
        <a-divider v-if="item.divider" type="vertical" />
        <a @click="actionCb(item.cb, scope.scope)">{{item.name}}</a>
      </span>
    </span>
    <span v-else>
      <span v-for="item in instance.list" :key="item.key">
        <a-divider v-if="item.divider" type="vertical" />
        <a @click="actionCb(item.cb, scope.scope)">{{item.name}}</a>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  data() {
    return {

    }
  },
  mounted(){
    
  },
  methods: {
    actionCb(cb, row) {
      this.$emit('actionClick', { cb, row })
    }
  }
}
</script>
